document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("imagePopup");
  const popupImg = document.getElementById("popupImage");
  const closeBtn = document.getElementById("popupClose");

  document.querySelectorAll(".lightbox-trigger").forEach(img => {
    img.addEventListener("click", () => {
      popupImg.src = img.src;
      popup.classList.add("show");
    });
  });

  closeBtn.addEventListener("click", () => {
    popup.classList.remove("show");
  });

  popup.addEventListener("click", (e) => {
    if (e.target === popup) {
      popup.classList.remove("show");
    }
  });
});
